import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { useTheme } from 'styled-components';
import SmartBanner from '../../../components/SmartBanner';
import BadgeContainer from './BadgeContainer';
import { Container, LogoAsset } from './styledComponents';

const DefaultStoreDownload = () => {
  const { StoreDownload } = useTheme();
  return (
    <div>
      <SmartBanner style={{ position: 'unset' }} />
      <Container theme={StoreDownload.Container}>
        <LogoAsset src={assetSource(ASSET_KEY.LOGO)} alt="logo" />
        <p>Experience the thrill of an exciting new gaming experience!</p>
        {ENVIRONMENT_VARIABLES.APPLE_STORE_URL && (
          <BadgeContainer url={ENVIRONMENT_VARIABLES.APPLE_STORE_URL} badge={ASSET_KEY.BADGE_I_OS} />
        )}
        {ENVIRONMENT_VARIABLES.ANDROID_STORE_URL && (
          <BadgeContainer url={ENVIRONMENT_VARIABLES.ANDROID_STORE_URL} badge={ASSET_KEY.BADGE_ANDROID} />
        )}
      </Container>
    </div>
  );
};
export default DefaultStoreDownload;

